import { Alert, Container, Stack } from '@mantine/core';

export const OrderCheckoutComplete = () => {
  return (
    <Container mt="md">
      <Stack>
        <Alert color="teal" title="Objednávka dokončená">
          Objednávka bola úspešne dokončená. Ďalsie informácie o objednávke Vám budú zaslané do
          správy. Ak by ste potrebovali v objednávke niečo ešte zmeniť, kontaktujte nás.
        </Alert>
      </Stack>
    </Container>
  );
};
